module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage5.ceeb8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage5.png
// module id = kg4n
// module chunks = 0